<template>
  <div class="vision-page">
    <h1 class="vision-title">Our Vision</h1>
    <section class="vision-gallery">
      <div class="vision-item">
        <img src=";lkjjh.png" alt="Teamwork" class="vision-img" />
        <p class="vision-desc">We encourage teamwork and collaboration to solve real-world problems.</p>
      </div>
      <div class="vision-item">
        <p class="vision-desc">To nurture creativity, critical thinking, and innovation in every student, equipping them with future-ready skills that align with Egypt’s Vision 2030 and the global digital transformation.</p>
        <img src="kdjhf.png" alt="Innovation" class="vision-img" />
      </div>
      
      
    </section>
  </div> 
</template>
<script>
export default { name: 'VisionPage' };
</script>
<style scoped>
.vision-page {
  padding: 2rem;
  text-align: center;
}
.vision-title {
  font-size: 2.5rem;
  color: #1976d2;
  margin-bottom: 2rem;
}
.vision-gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
}
.vision-item {
  max-width: 300px;
  text-align: center;
}
.vision-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
}
.vision-desc {
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
}
</style>
